import React from "react";

const TraslateHome = ({ cambiarId }) => {
    const id1 = "/paginaspanish/6616aa73fe1c4874293993a1"; //Variable en español
    const id2 = "/paginas/6616a58bfe1c487429399328"; //Variable en Ingles

    return (
        <div
            className="w-full h-screen relative flex items-center bg1"
        >
            <div className="relative flex flex-col items-center w-full">
                <img
                    src="https://firebasestorage.googleapis.com/v0/b/recursos-31efd.appspot.com/o/Essential-Electrical-Services.gif?alt=media&token=f8d43020-4597-4192-aec7-b0ea0b295f44"
                    alt="no-logo"
                    className="w-[80%] md:w-[30%] pb-5"
                />
                <h1 className="text-white capitalize pb-5">Sitio / Site</h1>
                <div className="flex">
                    <div className="mr-3">
                        <button
                            onClick={() => cambiarId({id: id1, l: 'es'})}
                            className="px-5 py-3 rounded-2xl bg-red-900"
                        >
                            Español
                        </button>
                    </div>
                    <div className="ml-3">
                        <button
                            onClick={() => cambiarId({id: id2, l: 'en'})}
                            className="px-5 py-3 rounded-2xl bg-red-600"
                        >
                            English
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default TraslateHome
